// This is generated.  Alter it in blockGroups/dataViews/types/shortTextView.js
/* eslint-disable no-unused-vars */
const { Type } = require('@sinclair/typebox');
const { actionUtils } = require('@sstdev/lib_metadata-config');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');
module.exports = {
  asDataDictionary: function asDataDictionary(
    hNode,
    context = {},
    parentAccessRestrictions,
  ) {
    const { namespace, relation, propertyName } = hNode;

    const accessRestrictions = actionUtils.getNodeAccessRestrictions(
      hNode,
      context,
      parentAccessRestrictions,
    );
    if (accessRestrictions.hidden) return [{}, {}];

    // shortTextView displays read-only text from a namespace/relation property
    // It only requires GET access to read the data
    const accessContext = {
      get: { value: true },
      post: { value: false },
      patch: { value: false },
      remove: { value: false },
    };

    // Build a relation schema that indicates we need read access to this relation
    // The actual property type is unknown at design time, so we use additionalProperties: true
    const relationSchema = Type.Object(
      {},
      {
        title: relation,
        additionalProperties: true,
        'x-accessRestrictions': accessRestrictions,
        'x-accessContext': accessContext,
      },
    );

    // subDataDictionary defines the namespace/relation structure for metadata assembly
    const subDataDictionary = {
      [namespace]: {
        [relation]: relationSchema,
      },
    };

    // shortTextView is read-only display, it doesn't contribute properties to a form
    const partialTypeDefinition = {};

    return [subDataDictionary, partialTypeDefinition];
  },
};
moduleRegistration.registerHNodeType(
  'dataViews',
  'shortTextView',
  module.exports,
);
